/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MongoDataDocumentsDto } from '../../models/mongo-data-documents-dto';

export interface GetMongoDataDocuments$Params {
  collection: string;
  '$page': number;
  '$maxpagesize': number;
  fromDate?: string;
  toDate?: string;
  'X-API-Version'?: string;
}

export function getMongoDataDocuments(http: HttpClient, rootUrl: string, params: GetMongoDataDocuments$Params, context?: HttpContext): Observable<StrictHttpResponse<MongoDataDocumentsDto>> {
  const rb = new RequestBuilder(rootUrl, getMongoDataDocuments.PATH, 'get');
  if (params) {
    rb.path('collection', params.collection, {});
    rb.query('$page', params['$page'], {});
    rb.query('$maxpagesize', params['$maxpagesize'], {});
    rb.query('fromDate', params.fromDate, {});
    rb.query('toDate', params.toDate, {});
    rb.header('X-API-Version', params['X-API-Version'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MongoDataDocumentsDto>;
    })
  );
}

getMongoDataDocuments.PATH = '/api/mongo-data/collections/{collection}/documents';
